<template>
    <!--コンテンツ-->
    <main id="renew2_category">
    <div class="renew2_category">
        <div class="format">
            <div class="renew2_wrapper">
                <div class="renew2_flex format_lead">
                    <div class="format__h2">
                        <h2 class="renew2_category__h2">フォーマットをえらぼう</h2>
                    </div>
                    <div class="format__h3">
                        <h3 class="renew2_category__h3">どれを書く？</h3>
                    </div>
                </div>

                <p>バックアップ機能（最後まで入力）もあり安心して作成することができます。<br>
                    また、一度作成した書類も入力ページに戻ると修正可能です。</p>
            </div>

            <!--どれを書くの場合-->
            <ul class="format__choice02 renew2_flex renew2_sp_flex renew2_wrapper">
                <li class="choice02_item select"><a href="/rirekisyo_format_all">すべて</a></li>
                <li class="choice02_item"><a href="/rirekisyo_format">履歴書</a></li>
                <li class="choice02_item"><a href="/keirekisyo_format">職務経歴書</a></li>
                <li class="choice02_item"><a href="/letter_format">送付状</a></li>
            </ul>

            <div class="format_block">
                <div class="renew2_wrapper">
                    <div id="rirekisyo_format" class="rirekisyo">
                        <div class="renew2_flex renew2_sp_flex format_block__list01">
                            <h3>履歴書</h3>
                        </div>
                        <div class="format_block__list02 renew2_flex renew2_sp_flex">
                            <a :href="'/format/'+f.id"
                              :key="f.id"
                              v-for="f in $site.rirekishoFormatsIndex"
                              class="format_item">
                                <div class="format_img">
                                    <img :src="f.thumbnail" :alt="f.title + 'テンプレート'">
                                    <!-- <img src="/static/renew2_img/rirekisho_job_change.png" :alt="f.title + 'テンプレート'"> -->
                                </div>
                                <div class="format_txt">
                                    <div class="renew2_flex renew2_sp_flex memo">
                                        <p>A4</p>
                                        <p>{{ f.pagenumbs }}</p>
                                    </div>
                                    <h3 class="h3">{{ f.title }}</h3>
                                    <p class="txt">{{ f.newdetail }}</p>
                                </div>
                                <button class="format_btn">この履歴書でつくる</button>
                            </a>
                        </div>
                    </div>
                    <div id="keirekisyo_format" class="keirekisyo">
                        <div class="renew2_flex renew2_sp_flex format_block__list01">
                            <h3>職務経歴書</h3>
                        </div>
                        <p class="print_memo">※コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応</p>
                        <div class="format_block__list02 renew2_flex renew2_sp_flex">
                            <a :href="'/format/'+f.id"
                              :key="f.id"
                              v-for="f in $site.keirekishoFormatsIndex"
                               class="format_item">
                                <div class="format_img">
                                    <img :src="f.thumbnail" :alt="f.title + 'テンプレート'">
                                </div>
                                <div class="format_txt">
                                    <div class="renew2_flex renew2_sp_flex memo">
                                        <p>A4</p>
                                    </div>
                                    <h3 class="h3">{{ f.title }}</h3>
                                    <p class="txt">{{ f.newdetail }}</p>
                                </div>
                                <button class="format_btn" style="background-color:#E95B10">この経歴書でつくる</button>
                            </a>
                        </div>
                    </div>
                    <div id="letter_format" class="letter format_block">
                        <div class="renew2_flex renew2_sp_flex format_block__list01">
                            <h3>送付状</h3>
                        </div>
                        <div class="format_block__list02 renew2_flex renew2_sp_flex">
                            <a :href="'/format/'+f.id"
                              :key="f.id"
                              v-for="f in $site.letterFormatsIndex"
                               class="format_item">
                                <div class="format_img">
                                    <img :src="f.thumbnail" :alt="f.title + 'テンプレート'">
                                </div>
                                <div class="format_txt">
                                    <div class="renew2_flex renew2_sp_flex memo">
                                        <p>A4</p>
                                    </div>
                                    <h3 class="h3">{{ f.title }}</h3>
                                </div>
                                <button class="format_btn" style="background-color:#E95B10">送付状をつくる</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="column_block renew2_wrapper">
                <h3 class="column_h3">おすすめの記事</h3>
                <div class="renew2_flex renew2_sp_flex column_list">
                    <a href="" class="column_item">
                        <div class="column_img">
                            <img src="https://www.ghibli.jp/gallery/chihiro014.jpg" alt="履歴書の書き方">
                        </div>
                        <div class="column_txt">
                            <h3 class="h3">履歴書の書き方</h3>
                        </div>
                    </a>
                    <a href="" class="column_item">
                        <div class="column_img">
                            <img src="https://www.ghibli.jp/gallery/chihiro015.jpg" alt="履歴書の書き方">
                        </div>
                        <div class="column_txt">
                            <h3 class="h3">職務経歴書の書き方</h3>
                        </div>
                    </a>
                    <a href="" class="column_item">
                        <div class="column_img">
                            <img src="https://www.ghibli.jp/gallery/chihiro007.jpg" alt="履歴書の書き方">
                        </div>
                        <div class="column_txt">
                            <h3 class="h3">ああああああああああああああああああああ</h3>
                        </div>
                    </a>
                </div>
            </div>

            <div class="backlink_block renew2_wrapper">
                <a href="" class="backlink_link">だれが書く？<br class="sp">
                    <span class="backlink_link_txt">＼転職？学生？／<br class="sp">自分の立場に合わせてフォーマットを選ぼう！</span>
                </a>
            </div>
        </div>
    </div>
    </main>
</template>

<style scoped>
    #renew2_category .format {
        margin: 30px auto 100px;
    }

    #renew2_category .format .format_lead {
        align-items: center;
        margin-bottom: 15px;
    }

    #renew2_category .format__h2 {
        text-align: center;
    }

    #renew2_category .format__h2 .renew2_category__h2 {
        font-size: 1.2rem;
    }

    #renew2_category .format__h3 {
        text-align: center;
    }

    #renew2_category .renew2_category__h3 {
        margin: 5px;
        background: #004D40;
        color: #fff;
        border-radius: 35px;
        display: inline-block;
        padding: 5px 30px;
    }

    #renew2_category .format__choice02 {
        margin-top: 10px;
        overflow-x: scroll;
    }

    #renew2_category .format__choice02 .choice02_item {
        position: relative;
        margin-right: 20px;
        background: #EEF5E8;
        padding: 2px 20px 2px 15px;
        border-radius: 30px;
        white-space: nowrap;
    }

    #renew2_category .format__choice02 .choice02_item:last-child {
        margin-right: 0;
    }

    #renew2_category .format__choice02 .choice02_item::after {
        position: absolute;
        content: "";
        background-image: url(/static/renew2_img/icon_link_toggle.svg);
        background-repeat: no-repeat;
        top: 30%;
        right: 0;
        width: 15px;
        height: 15px;
    }

    #renew2_category .format__choice02 .select {
        background: #004D40;
    }

    #renew2_category .format__choice02 .select a {
        color: #fff;
    }

    #renew2_category .format .renew2_wrapper {
        width: 768px;
    }

    #renew2_category .format .format_block {
        background: #EEF5E8;
        padding-bottom: 30px;
    }

    #renew2_category .format .format_block__list01 {
        margin: 20px auto 30px;
        padding-top: 20px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    #renew2_category .format .format_block__list01 h3 {
        margin-right: 30px;
        font-size: 1rem;
    }

    #renew2_category .format .format_block__list01 .category .category_item {
        background: #fff;
        color: #0F9934;
        font-weight: bold;
        margin-right: 10px;
        padding: 2px 15px;
        border: 1px solid #0F9934;
        border-radius: 25px;
        text-align: center;
    }

    #renew2_category .format .format_block__list01 .category .select {
        background: #0F9934;
        color: #fff;
    }

    #renew2_category .format .format_block__list02 {
        margin: 20px auto;
        margin-bottom: 0;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }

    #renew2_category .format .format_block__list02::after {
        content: "";
        display: block;
        width: calc(33.3333333333% - 15px);
    }

    #renew2_category .format .format_block__list02 .format_item {
        width: calc(33.3333333333% - 15px);
        margin-bottom: 30px;
        -webkit-filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
        filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
    }

    #renew2_category .format .format_block__list02 .format_item .format_img {
        text-align: center;
        background: #DFDFDF;
        height: 90px;
        overflow: hidden;
        border-radius: 5px 5px 0 0;
    }

    #renew2_category .format .format_block__list02 .format_item .format_img img {
        width: 70%;
        padding-top: 10px;
    }

    #renew2_category .format .format_block__list02 .format_item .format_txt {
        background: #fff;
        padding: 10px;
    }

    #renew2_category .format .format_block__list02 .format_item .format_txt .memo p {
        font-size: 0.6rem;
        font-weight: bold;
        color: #E95B10;
        border: 1px solid #E95B10;
        padding: 0px 10px;
        margin-right: 5px;
        border-radius: 25px;
    }

    #renew2_category .format .format_block__list02 .format_item .format_txt .h3 {
        font-size: 1rem;
    }

    #renew2_category .format .format_block__list02 .format_item .format_txt .txt {
        font-size: 0.8rem;
    }

    #renew2_category .format .format_block__list02 .format_item .format_btn {
        width: 100%;
        padding: 10px;
        border: none;
        font-size: 1rem;
        font-weight: bold;
        color: #fff;
        background: #0F9934;
        border-radius: 0 0 5px 5px;
    }

    #renew2_category .format .keirekisyo .format_block__list02 .format_item .format_btn {
        width: 100%;
        padding: 10px;
        border: none;
        font-size: 1rem;
        font-weight: bold;
        color: #fff;
        background: rgb(233, 91, 16);
        border-radius: 0 0 5px 5px;
    }

    #renew2_category .format .keirekisyo .format_block__list01 {
        margin-top: 0;
        margin-bottom: 10px;
    }

    #renew2_category .format .keirekisyo .print_memo {
        width: 768px;
        margin: 0 auto;
    }

    #renew2_category .format .letter .format_block__list01 {
        margin-top: 0;
        margin-bottom: 10px;
    }

    #renew2_category .format .column_block{
        margin-top: 50px;
    }

    #renew2_category .format .column_block .column_list{
        justify-content: space-between;
        flex-direction: row;
        overflow-x: scroll;
        margin-bottom: 50px;
    }

    #renew2_category .format .column_block .column_h3{
        font-size: 1.2rem;
        margin-bottom: 15px;
    }

    #renew2_category .format .column_block .column_item{
        width: calc(33.3333333333% - 15px);
        background: #EEF5E8;
        border-radius: 8px;
    }

    #renew2_category .format .column_block .column_txt{
        margin-top: 5px;
    }

    #renew2_category .format .column_block .column_txt h3{
        font-size: 1rem;
        padding: 7px 15px 15px;
    }

    /*#renew2_category .format .backlink_block{
    }*/

    #renew2_category .format .backlink_block .backlink_link{
        color: #fff;
        font-size: 1.2rem;
        font-weight: bold;
        padding: 30px;
        background: #0F9934;
        border-radius: 10px;
        display: inline-block;
        width: 100%;
        text-align: center;
        -webkit-filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
        filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
    }

    #renew2_category .format .backlink_block .backlink_link .backlink_link_txt{
        font-size: 1rem;
        display: inline-block;
        margin-top: 5px;
    }

    @media screen and (max-width: 640px) {
        #renew2_category .format {
            width: 100%;
        }

        #renew2_category .format .format_block__list01 {
            width: 100%;
        }

        #renew2_category .format .format_block__list02 {
            width: 100%;
        }

        #renew2_category .format .keirekisyo .print_memo {
            width: 100%;
            font-size: 0.8rem;
        }

        #renew2_category .format .format_block__list01 {
            overflow-x: scroll;
        }

        #renew2_category .format .format_block__list01 h3 {
            white-space: nowrap;
        }

        #renew2_category .format .format_block__list01 .category .category_item {
            min-width: 80px;
        }

        #renew2_category .format .format_block__list02 .format_item {
            width: calc(50% - 10px);
        }

        #renew2_category .format .format_block__list02 .format_item .format_txt .txt {
            font-size: 0.7rem;
        }

        #renew2_category .format .column_block .column_item{
            margin-right: 15px;
            flex-shrink: 0;
            width: 200px;
        }
    }
</style>

<script>

export default {
  components: {
  },
  data: function () {
    return {

    }
  },
  methods: {},
  computed: {},
  created: function () {}
}
</script>
